const StartProcessByNameRequest = function () {
  return {
    "processName": "",
    "variables": []
  };
};

export default StartProcessByNameRequest;



// WEBPACK FOOTER //
// ./src/service/request/StartProcessByNameRequest.js